import { Component } from "react";
import { connect } from "react-redux";

// @mui material components
import Grid from "@mui/material/Grid";

import FormSelect from "components/DigiHapi/FormSelect";

import {
	SET_TEMPLATE_DATE,
	SET_TEMPLATE_TIME,
	SET_TEMPLATE_EQUIPMENT
} from "actions/types";

const toOptions = data =>
	(data || []).map(({ _id, name }) => ({ value: _id, label: name }));

class Step4 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		return true;
	}

	render() {
		const {
			dispatch,
			isFetching,
			dates,
			times,
			equipments,
			dateId,
			timeId,
			equipmentId,
			displayTime
		} = this.props;

		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					<FormSelect
						label="Jour"
						value={dateId}
						placeholder="Sélectionner jour"
						placeholderSelectable
						options={toOptions(dates)}
						onChange={(e, child) =>
							dispatch({
								type: SET_TEMPLATE_DATE,
								dateId: e.target.value,
								text: child.props.children
							})
						}
						disabled={isFetching}
					/>
				</Grid>
				{displayTime && (
					<Grid item xs={12}>
						<FormSelect
							label="Heure"
							value={timeId}
							placeholder="Sélectionner heure"
							placeholderSelectable
							options={toOptions(times)}
							onChange={e =>
								dispatch({
									type: SET_TEMPLATE_TIME,
									timeId: e.target.value
								})
							}
							disabled={isFetching}
						/>
					</Grid>
				)}
				<Grid item xs={12}>
					<FormSelect
						label="Lieu de rendez-vous"
						value={equipmentId}
						placeholder="Sélectionner lieu de rendez-vous"
						placeholderSelectable
						options={toOptions(equipments)}
						onChange={e =>
							dispatch({
								type: SET_TEMPLATE_EQUIPMENT,
								equipmentId: e.target.value
							})
						}
						disabled={isFetching}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const { dateId, timeId, equipmentId, dates, displayTime } =
		state.templateReducer;

	const { templateTimes } = state.entitiesReducer;
	const { equipments } = state.equipmentReducer;

	return {
		dates: Object.values(dates),
		times: Object.values(templateTimes),
		equipments: equipments && Object.values(equipments),
		dateId,
		timeId,
		equipmentId,
		displayTime
	};
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(
	Step4
);
